import Vue from 'vue';
import VueIziToast from 'vue-izitoast';
 
//import 'izitoast/dist/css/iziToast.css';
import 'izitoast/dist/css/iziToast.min.css';
 
Vue.use(VueIziToast);
//Vue.use(VueIziToast, defaultOptionsObject);

export default VueIziToast